// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"StopGo_pageHeader__1C1gs","add":"StopGo_add__1t2jc"};